var _rect, _rect2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotCut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 48,
    viewBox: "0 0 65 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005356"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Image",
    x: 1.5,
    y: 1,
    width: 62,
    height: 46,
    rx: 7,
    fill: "#EEF2F5",
    stroke: "#FB6E4F",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_725_10300",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 53,
    height: 42
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624284",
    x: 2.5,
    y: 3,
    width: 52,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_725_10300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004307",
    filter: "url(#filter0_d_725_10300)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624147",
    x: -8.5,
    y: 9,
    width: 51.8182,
    height: 30,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624148",
    d: "M-4.9707 19.2383C-4.9707 18.1337 -4.07527 17.2383 -2.9707 17.2383H8.0293C9.13387 17.2383 10.0293 18.1337 10.0293 19.2383V34.2971H-4.9707V19.2383Z",
    fill: "#19184A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624149",
    d: "M-4.9707 34.2948C-4.9707 30.7212 -2.07372 27.8242 1.49988 27.8242H3.55871C7.13232 27.8242 10.0293 30.7212 10.0293 34.2948H-4.9707Z",
    fill: "#558BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624150",
    x: -4.21387,
    y: 13.2852,
    width: 36.4286,
    height: 2.14286,
    fill: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624153",
    x: 34.3574,
    y: 13.2852,
    width: 4.28571,
    height: 2.14286,
    fill: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624156",
    x: 12.9287,
    y: 19.7148,
    width: 25.7143,
    height: 2.14286,
    fill: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624164",
    x: 12.9287,
    y: 26.1445,
    width: 25.7143,
    height: 2.14286,
    fill: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624165",
    x: 12.9287,
    y: 32.5703,
    width: 25.7143,
    height: 2.14286,
    fill: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 67",
    cx: 2.52124,
    cy: 22.8474,
    r: 3.67359,
    fill: "white"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2554",
    x: 47.5,
    y: 4,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#FB6E4F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 117",
    d: "M51.3232 7.82422L56.6762 13.1772",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 118",
    d: "M56.6768 7.82422L51.3238 13.1772",
    stroke: "white",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_725_10300",
    x: -10.5,
    y: 7,
    width: 55.8184,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_725_10300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_725_10300",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotCut);
export default __webpack_public_path__ + "static/media/NotCut.e9bb767fb2c9d9abac447da11ef05a7b.svg";
export { ForwardRef as ReactComponent };